module.exports = __webpack_public_path__ + "assets/images/magazine-gt_bfbb20f9bf9e2af0d62eae5ee89a446c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-6/magazine-gt.png
// module id = 283
// module chunks = 0